import type { PreviewColumn, PreviewRowCells } from '../state/api/organisationEngineSlice';

/**
 * Builds a CSV containing the manifest header followed by the cell values of
 * each failed row, in the order given. The header order, the cell-to-column
 * mapping, and the row order all come from the engine-supplied data — no
 * client-side schema or parser involved. Cells containing commas, quotes, or
 * newlines are RFC-4180-quoted with internal quotes doubled.
 *
 * Row entries without a `cells` payload are silently skipped — defensive
 * against drift between commit state and preview rows.
 */
export const serializeFailedRowsCsv = (
    failed: Array<{ rowNumber: number; cells: PreviewRowCells | undefined }>,
    columns: PreviewColumn[]
): string => {
    const headerLine = columns.map(c => quoteCell(c.label)).join(',');
    const lines = [headerLine];

    for (const { cells } of failed) {
        if (!cells) continue;
        lines.push(columns.map(col => quoteCell(cells[col.key] ?? '')).join(','));
    }

    return `${lines.join('\n')}\n`;
};

const needsQuoting = (value: string): boolean => value.includes(',') || value.includes('"') || value.includes('\n') || value.includes('\r');

const quoteCell = (value: string): string => {
    if (!needsQuoting(value)) return value;
    return `"${value.replace(/"/g, '""')}"`;
};
